import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const EventService = {
  getList: async () => {
    const response = await apiService.get("/event");
    return response.data;
  },

  getById: async (id) => {
    const response = await apiService.get(`/event/${id}`);
    return response.data;
  },

  getBySlug: async (id) => {
    const response = await apiService.get(`/event/slug?slug=${id}`);
    return response.data;
  },
    
}

export default EventService
